import React, { useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { useNewTermsAndConditions } from '../../../feature-flags/hooks/use-new-terms-and-conditions';
import { useModal } from '../../../hooks/use-modal';
import { LogService } from '../../../services/log-service';
import { UserPermissionService } from '../../../services/user-permission-service';
import Global from '../../../store/global-selectors';
import { hasAcceptedNewTermsAndConditions } from './api';
import { configs } from './new-terms-configs';

import { NewTermsModal } from './index';

export const NewTermsModalProvider = () => {
  const { close, isOpen, open } = useModal();
  const { enabled, mustAcceptByDateUTC, newTermsLabel } = useNewTermsAndConditions();
  const userRoles = useSelector(Global.selectUseruserRoles);
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);
  const isAdmin = UserPermissionService.userHasAdministrationRole(userRoles);

  const { country } = configs[newTermsLabel] ?? {};

  const pastDeadline = useMemo(() => {
    const now = new Date();
    const mustAcceptByDate = new Date(mustAcceptByDateUTC);
    return now > mustAcceptByDate;
  }, [mustAcceptByDateUTC]);

  useEffect(() => {
    (async () => {
      try {
        const subjectToTerms = enabled && sellerHomeCountry === country;
        const shouldCheckTerms = subjectToTerms && (isAdmin || pastDeadline);
        if (!shouldCheckTerms) {
          return;
        }
        const hasAcceptedTerms = await hasAcceptedNewTermsAndConditions(newTermsLabel);
        if (!hasAcceptedTerms) {
          open();
        }
      } catch (e) {
        LogService.logError(new Error('Error fetching seller terms and conditions acceptance', { cause: e }));
      }
    })();
  }, [country, enabled, isAdmin, newTermsLabel, open, pastDeadline, sellerHomeCountry]);

  return <>{isOpen && <NewTermsModal isAdmin={isAdmin} newTermsLabel={newTermsLabel} onClose={close} pastDeadline={pastDeadline} />}</>;
};
